export default __webpack_public_path__ + "static/media/conteudo_extra_05.045cce30.jpg";